import React from 'react';
import { Stack, Text } from '@moda/om';

import './AffirmPaymentMethodPreview.scss';

export const AffirmPaymentMethodPreview: React.FC = ({ children }) => (
  <Stack space={0} className="AffirmPaymentMethodPreview">
    <Stack space={1} direction="horizontal" alignItems="center">
      <img className="AffirmPaymentMethodPreview__affirm" alt="Affirm" src="/affirm.png" />
      <Text treatment="eyebrow">Payment Method</Text>
    </Stack>
    <Stack space={0} direction="horizontal" justifyContent="space-between">
      <Text>Your selected Affirm Payment Method</Text>
      {children}
    </Stack>
  </Stack>
);
